<ng-container>
  <div class="terms">
    @if (!isTermsAccepted) {
      <div class="terms--container">
        <div class="terms--container--header">
          <h2 class="terms--container--header--title">
            Termos de Uso e Privacidade
          </h2>
          <p>
            Os
            <b
              >Termos de Uso e Privacidade do Portal de Logons - Serasa Experian
            </b>
            foram atualizados em
            <b>{{ currentTerm?.creationDate | date : "dd/MM/yyyy" }}.</b>
          </p>
          <span>
            Para continuar, é necessário ler e aceitar o termo atualizado.
          </span>
        </div>
        @if (privacySelector$ | async; as terms) {
          <div>
            @if (terms[0].term) {
              <div
                class="terms--container--box seds-scrollbar"
                [innerHtml]="terms[0].term"
              ></div>
            }
          </div>
        }
        <div class="terms--container--accept-buttons">
          <seds-checkbox
            label="Li e aceito os Termos de Uso e Privacidade"
            [(model)]="checkAccepted"
          ></seds-checkbox>
          <seds-basic-button
            title="Continuar"
            [disabled]="!checkAccepted"
            (click)="registerAccepted()"
          ></seds-basic-button>
        </div>
      </div>
    } @else {
      <h2>Termos de Uso e Privacidade</h2>
      <section class="container">
        @if (!(privacyState$ | async)?.error) {
          <section
            class="container__approved"
            >
            <img
              src="/portal-logons/assets/icons/privacy/icon_check_success.svg"
              alt="Ícone de sucesso"
              />
            <span class="container__approved__title">Obrigado!</span>
            <span class="container__approved__description">
              Termos de Uso e Privacidade aceitos com sucesso!
            </span>
            <seds-loaders-spinner></seds-loaders-spinner>
          </section>
        }
        @if ((privacyState$ | async)?.error) {
          <section class="container__reproved">
            <img
              src="/portal-logons/assets/images/error.svg"
              alt="Imagem de indisponibilidade do serviço"
              />
            <span class="container__reproved__title">
              Não foi possível prosseguir com o aceite dos termos de uso.
            </span>
            <span class="container__reproved__description">
              Estamos trabalhando para resolver esse problema. <br />
              Por favor, tente novamente mais tarde e, se o erro persistir, entre em
              <br />
              contato com a nossa central de atendimento.
            </span>
          </section>
        }
      </section>
    }
  </div>
</ng-container>

